import React from "react";
import './MultiSelectCheckbox.css';

export interface Option {
    label: string;
    value: string;
}

interface MultiSelectCheckboxProps {
    options: Option[];
    value: string[];
    onChange: (selectedValues: string[]) => void;
}

const MultiSelectCheckbox: React.FC<MultiSelectCheckboxProps> = ({
    options,
    value,
    onChange,
}) => {
    const handleCheckboxChange = (optionValue: string) => {
        const isSelected = value.includes(optionValue);
        const updated = isSelected
            ? value.filter((v) => v !== optionValue)
            : [...value, optionValue];
        onChange(updated);
    };

    return (
        <div className="reg-view-multi-checkbox">
            <div className="reg-view-multi-checkbox-options">
                {options.map((option) => (
                    <label key={option.value} >
                        <input
                            type="radio"
                            value={option.value}
                            checked={value.includes(option.value)}
                            onChange={() => handleCheckboxChange(option.value)}
                        />
                        {option.label}
                    </label>
                ))}
            </div>
        </div>
    );
};

export default MultiSelectCheckbox;
